import type {WorkerManager} from '../../../../worker';
import {FeaturePreviewExecution} from '../FeaturePreviewExecution';
import type {RevolveFeatureDefinitionModel} from '../../../definition/revolve/RevolveFeatureDefinition';
import type {FeatureEditSession} from '../../../edit/FeatureEditSession';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/execution/preview/revolve 目录；
 * 2. 负责封装旋转特征的预览执行；
 * 3. 该执行器统一收口创建态与编辑态预览。
 */

/**
 * 旋转特征预览执行器。
 */
export class RevolvePreviewExecution extends FeaturePreviewExecution<RevolveFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(definition: RevolveFeatureDefinitionModel): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateRevolvePreview(definition.getCommandParams());
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<RevolveFeatureDefinitionModel>,
        definition: RevolveFeatureDefinitionModel,
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateRevolvePreviewInSandbox({
            commands: session.getPreviewCommands(),
            params: definition.getCommandParams(),
        });
    }
}
